import React from 'react';

import Button from '../Button/Button';
import ImportantInfo from '../ImportantInfo/ImportantInfo';

import './StepEmptySnils.pcss';

// typograf-enable
const StepEmptySnils = () => (
  <div className="StepEmptySnils">
    <div className="StepEmptySnils-content">
      <div className="StepEmptySnils-content__icon" />
      <div className="StepEmptySnils-content__title">Не проверен СНИЛС</div>
      <div className="StepEmptySnils-content__text">
        Воспользоваться услугой могут только пользователи с проверенным СНИЛС.
        Укажите СНИЛС в{' '}
        <a
          href="https://my.mos.ru/my/#/settings/profile"
          rel="noopener noreferrer"
          target="_blank"
        >
          Личном кабинете
        </a>{' '}
        и дождитесь его проверки.
        <div className="StepEmptySnils-content__text-info">
          Проверка СНИЛС занимает не более 24 часов.
        </div>
        <Button
          className="Lead__action-button"
          primary
          onClick={() => {
            window.location.href = 'https://my.mos.ru/my/#/settings/profile';
          }}
        >
          Перейти в Личный кабинет
        </Button>
      </div>
    </div>
    <ImportantInfo />
  </div>
);

export default StepEmptySnils;
